import "./src/styles/global.css";
import { inject } from "@vercel/analytics";

export const onClientEntry = () => {
  inject();
};
